import { render, staticRenderFns } from "./PurchaseCaseCard.vue?vue&type=template&id=f8fa8632&"
import script from "./PurchaseCaseCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseCaseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports